import { put, call, takeLatest } from 'redux-saga/effects';

import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';

import { allActionTypes } from './reducer';
import { tabs } from '../constants';

const appResourcesActionTypes = allActionTypes[tabs.firmwares];

function* getFiles() {
  yield requestSaga({
    actionType: appResourcesActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.firmware.index,
  });
}

function* archiveFiles() {
  yield requestSaga({
    actionType: appResourcesActionTypes.deleteData,
    request: dataProvider.updateOnly,
    resource: resources.firmware.archive,
  });
}

async function upload(file) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    const { data } = await dataProvider.createOneFormData(
      resources.firmware.upload,
      { body: formData }
    );

    return data;
  } catch (error) {
    return null;
  }
}

function* save(action) {
  const { payload, onSuccess } = action;
  const { file, ...restFileParams } = payload;

  try {
    const uploadedFile = yield call(upload, file);

    const fileData = {
      ...restFileParams,
      id: uploadedFile.id,
      storageFile: { ...uploadedFile, entityType: 'AppResources' },
    };

    const { data } = yield call(
      dataProvider.createOne,
      resources.firmware.index,
      fileData
    );
    yield put({
      type: appResourcesActionTypes.addOne.success,
      payload: { data },
    });

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    yield put({ type: appResourcesActionTypes.addOne.failed, payload: error });
  }
}

function* saveFile() {
  yield takeLatest(appResourcesActionTypes.addOne.requested, save);
}

export default [getFiles, saveFile, archiveFiles];
